<svg-icon [icon]="cell.row ? 'icon-circle-arrow-up' : 'icon-circle-arrow-down'"
          [class.green]="cell.row"
          [class.error]="!cell.row"
          class="tiny"
          ></svg-icon>